import { useEffect, useState } from "react";
import { jobService } from "../../utils/jobService";
import ApplyWithoutRegistration from "./apply-without-registration";

export default function JobDetail({ job, onClose }) {
  const [showApplyForm, setShowApplyForm] = useState(false);
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEscape);
    document.body.style.overflow = "hidden"; // Prevent background scrolling

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  // Map API fields to display fields
  const jobTitle = job.position_title || job.public_job_title || job.title || "Untitled Position";
  const postedDate = job.created || job.modified || job.posted_date;
  const formattedDate = postedDate ? jobService.formatDateForDisplay(postedDate) : null;
  
  // Build location string
  const locationParts = [];
  if (job.city) locationParts.push(job.city);
  if (job.state) locationParts.push(job.state);
  if (job.country) locationParts.push(job.country);
  const location = locationParts.length > 0 ? locationParts.join(", ") : null;
  
  // Get full job description - prefer public_job_desc, then requisition_description
  const fullDescription = job.public_job_desc || job.requisition_description || job.description || "No description available.";
  
  // Get skills
  const skills = job.skills || "";
  
  // Get job type and other details
  const jobType = job.job_type || job.employment_type || "";
  const remoteOpportunities = job.remote_opportunities || "";
  const closingDate = job.closing_date || "";
  
  // Get apply URL (kept for reference, but we'll use our own form)
  const applyUrl = job.apply_job || job.apply_job_without_registration || job.apply_url || null;

  const handleApply = () => {
    // Show the apply form modal instead of redirecting
    setShowApplyForm(true);
  };

  const handleApplyFormClose = () => {
    setShowApplyForm(false);
  };

  const handleApplySuccess = (applicationData) => {
    // Optional: Handle successful application submission
    // The form will auto-close after 3 seconds
  };

  return (
    <div className="job-detail-overlay" onClick={onClose}>
      <div className="job-detail" onClick={(e) => e.stopPropagation()}>
        <button className="job-detail__close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="job-detail__header">
          <h1 className="job-detail__title">{jobTitle}</h1>
          {job.job_code && <p className="job-detail__job-code">Job Code: {job.job_code}</p>}
        </div>

        <div className="job-detail__meta">
          {location && (
            <div className="job-detail__meta-item">
              <strong>Location:</strong> {location}
            </div>
          )}
          {formattedDate && (
            <div className="job-detail__meta-item">
              <strong>Posted:</strong> {formattedDate}
            </div>
          )}
          {jobType && (
            <div className="job-detail__meta-item">
              <strong>Job Type:</strong> {jobType}
            </div>
          )}
          {remoteOpportunities && (
            <div className="job-detail__meta-item">
              <strong>Remote:</strong> {remoteOpportunities}
            </div>
          )}
          {closingDate && closingDate !== "Open Until Filled" && (
            <div className="job-detail__meta-item">
              <strong>Closing Date:</strong> {closingDate}
            </div>
          )}
        </div>

        {skills && (
          <div className="job-detail__skills">
            <strong>Skills:</strong> {skills}
          </div>
        )}

        <div className="job-detail__content">
          <h2 className="job-detail__section-title">Job Description</h2>
          <div
            className="job-detail__description"
            dangerouslySetInnerHTML={{ __html: fullDescription }}
          />
        </div>

        <div className="job-detail__footer">
          <button className="job-detail__apply-btn" onClick={handleApply}>
            Apply Now
            <span className="job-detail__arrow">→</span>
          </button>
        </div>
      </div>

      {/* Apply Without Registration Form Modal */}
      {showApplyForm && (
        <ApplyWithoutRegistration
          job={job}
          onClose={handleApplyFormClose}
          onSuccess={handleApplySuccess}
        />
      )}
    </div>
  );
}

